import { yupResolver } from "@hookform/resolvers/yup";

import PillButton from "components/button/Pills";
import Input from "components/Input";
import { showToast } from "components/Toaster";
import { FormProvider, useForm } from "react-hook-form";
import httpClient from "services/network/httpClient";
import * as yup from "yup";

export interface ProductProps {
  productCode: string;
  productName: string;
}

const schema = yup.object({
  productCode: yup.string().trim().required("Please enter your Product Code"),
  productName: yup
    .string()
    .trim()
    .matches(
      /^[-a-zA-Z0-9 .]+$/,
      "Product Name can only contain letters, numbers, spaces, dots (.) and hyphens (-)"
    )
    .required("Please enter your Product Name"),
});

interface AddProductProps {
  onClose: () => void;
  getData: () => void;
}

const AddProduct = ({ onClose, getData }: AddProductProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const submit = (data: ProductProps) => {
    // Final validation before submission
    const specialCharsRegex = /[^a-zA-Z0-9 .-]/g;
    if (specialCharsRegex.test(data.productName)) {
      showToast("Product Name cannot contain special characters", "error");
      return;
    }

    console.log(data);
    httpClient
      .post("product/create", data)
      .then((response: any) => {
        console.log(response);
        if (response.success === true) {
          showToast("Product details added successfully", "success");
        } else {
          showToast(`${response.error.message}`, "error");
        }
      })
      .catch((error) => {
        console.log(error);
        showToast("something went wrong");
      })
      .finally(() => {
        onClose();
        getData();
      });
  };
  const handleProductNameChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9 .-]/g, '');

    // Set the input field value and update React Hook Form
    if (value !== sanitizedValue) {
      e.target.value = sanitizedValue;
      // Manually trigger React Hook Form field change
      methods.setValue("productName", sanitizedValue, { shouldValidate: true });
    }
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(submit)}
        className=" md:m-10 flex flex-col gap-5"
      >
        <Input
          name={"productCode"}
          label={"Product Code"}
          placeholder="Enter Product Code"
          required={true}
        ></Input>
        <Input
          name={"productName"}
          label={"Product Name"}
          placeholder="Enter Product Name"
          required={true}
          onChange={handleProductNameChange}


        ></Input>
        <div className="md:flex gap-10  items-center justify-center md:justify-end ml-20">
          <PillButton type="submit" className="flex-1" variant="secondary">
            {" "}
            Submit{" "}
          </PillButton>
          <PillButton type="reset" onClick={onClose} variant="primary">
            {" "}
            Cancel{" "}
          </PillButton>
        </div>
      </form>
    </FormProvider>
  );
};
export default AddProduct;
